import { fillArr } from '@hglobal/fin-ui';

import { Currency } from '@iw/core/entities';

const fiatCurrencies = [
  {
    name: 'US Dollar',
    symbol: 'USD',
    icon: 'usd.png',
    minAmount: '0.01',
    decimals: 2,
  },
  {
    name: 'Euro',
    symbol: 'EUR',
    icon: 'eur.png',
    minAmount: '0.01',
    decimals: 2,
  },
  {
    name: 'Ukrainian Hryvnia',
    symbol: 'UAH',
    icon: 'uah.png',
    minAmount: '1',
    decimals: 2,
  },
  {
    name: 'Kazakhstani Tenge',
    symbol: 'KZT',
    icon: 'kzt.png',
    minAmount: '10',
    decimals: 2,
  },
  {
    name: 'Indian Rupee',
    symbol: 'INR',
    icon: 'inr.png',
    minAmount: '5',
    decimals: 2,
  },
];

export function getCurrenciesMock(count = fiatCurrencies.length): Currency[] {
  const now = new Date().toISOString();

  return fillArr(count, (i) => {
    const { name, symbol, icon, minAmount, decimals } =
      fiatCurrencies[i % fiatCurrencies.length];
    return {
      id: `${i + 1}`,
      name,
      symbol,
      icon,
      isCrypto: false,
      minAmount,
      network: '',
      createdAt: now,
      updatedAt: now,
      decimals,
    };
  });
}

export const currenciesMock: Currency[] = [
  {
    id: 'fb3bfa07-1574-46b6-8a5f-00fd9ef187c8',
    name: 'US Dollar',
    symbol: 'USD',
    network: '',
    minAmount: '0.01',
    icon: '',
    isCrypto: false,
    createdAt: '2025-08-21T13:39:35.940417Z',
    updatedAt: '2025-08-21T13:39:35.940417Z',
    decimals: 2,
  },
  {
    id: '7cdc2c0a-7b55-47bb-baaa-ce82cb3de55c',
    name: 'Euro',
    symbol: 'EUR',
    network: '',
    minAmount: '0.01',
    icon: '',
    isCrypto: false,
    createdAt: '2025-08-21T13:39:35.940417Z',
    updatedAt: '2025-08-21T13:39:35.940417Z',
    decimals: 2,
  },
  {
    id: '3b1b0189-d4ca-49f4-be9a-5e310d37a7d2',
    name: 'Ukrainian Hryvnia',
    symbol: 'UAH',
    network: '',
    minAmount: '0.01',
    icon: '',
    isCrypto: false,
    createdAt: '2025-08-21T13:39:35.940417Z',
    updatedAt: '2025-08-21T13:39:35.940417Z',
    decimals: 2,
  },
  {
    id: 'dbf79e3f-d44e-4372-aadb-9f0f0a78405a',
    name: 'Kazakhstani Tenge',
    symbol: 'KZT',
    network: '',
    minAmount: '0.01',
    icon: '',
    isCrypto: false,
    createdAt: '2025-08-21T13:39:35.940417Z',
    updatedAt: '2025-08-21T13:39:35.940417Z',
    decimals: 2,
  },
  {
    id: 'f6aa7146-5c59-4dde-8d63-d2d588e8f288',
    name: 'Indian Rupee',
    symbol: 'INR',
    network: '',
    minAmount: '0.01',
    icon: '`',
    isCrypto: false,
    createdAt: '2025-08-21T13:39:35.940417Z',
    updatedAt: '2025-08-21T13:39:35.940417Z',
    decimals: 2,
  },
  {
    id: 'fb3bfa07-1574-46b6-8a5f-00fd9ef187c8',
    name: 'US Dollar',
    symbol: 'USD',
    network: '',
    minAmount: '0.01',
    icon: '',
    isCrypto: false,
    createdAt: '2025-08-21T13:39:35.940417Z',
    updatedAt: '2025-08-21T13:39:35.940417Z',
    decimals: 2,
  },
  {
    id: 'fb3bf777-1574-46b6-8a5f-00fd9ef187c8',
    name: 'BTC',
    symbol: 'BTC',
    network: 'Bitcoin',
    minAmount: '0.0001',
    icon: '',
    isCrypto: true,
    createdAt: '2025-08-21T13:39:35.940417Z',
    updatedAt: '2025-08-21T13:39:35.940417Z',
    decimals: 2,
  },
];
